import * as vindiciaUrl from './vindiciaUrl/reducer'


export default {
  vindiciaUrl,
}
